var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "客户变更",
            visible: _vm.show,
            size: "95%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                disabled: _vm.type == "查看" || _vm.isRejectTo,
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "申请单号" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客户编码",
                                prop: "customerApplyNo",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { disabled: true },
                                  model: {
                                    value: _vm.form.customerApplyNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "customerApplyNo", $$v)
                                    },
                                    expression: "form.customerApplyNo",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    staticStyle: { background: "white" },
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectCustomer },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客户名称",
                                prop: "customerApplyName",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.customerApplyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customerApplyName", $$v)
                                  },
                                  expression: "form.customerApplyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客户类型",
                                prop: "customerType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.form.customerType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "customerType", $$v)
                                    },
                                    expression: "form.customerType",
                                  },
                                },
                                _vm._l(_vm.customerType, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      value: item.code,
                                      label: item.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "经营类别",
                                prop: "operateCategory",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.form.operateCategory,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "operateCategory", $$v)
                                    },
                                    expression: "form.operateCategory",
                                  },
                                },
                                _vm._l(_vm.businessCategory, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      value: item.code,
                                      label: item.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人", prop: "contacts" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.contacts,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contacts", $$v)
                                  },
                                  expression: "form.contacts",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系方式",
                                prop: "contactsPhone",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.form.contactsPhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contactsPhone", $$v)
                                  },
                                  expression: "form.contactsPhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "地区", prop: "areaId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.form.areaId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "areaId", $$v)
                                    },
                                    expression: "form.areaId",
                                  },
                                },
                                _vm._l(_vm.areaOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      value: item.id,
                                      label: item.provinceName,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "省/市/区", prop: "provinceId" },
                            },
                            [
                              _vm.showRegion
                                ? _c("el-cascader", {
                                    attrs: {
                                      props: _vm.cascaderProps,
                                      options: _vm.areaData,
                                    },
                                    on: { change: _vm.addressChoose },
                                    model: {
                                      value: _vm.form.region,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "region", $$v)
                                      },
                                      expression: "form.region",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "详细地址", prop: "address" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.address,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "address", $$v)
                                  },
                                  expression: "form.address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务员", prop: "salesman" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "input-with-select",
                                  model: {
                                    value: _vm.form.salesman,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "salesman", $$v)
                                    },
                                    expression: "form.salesman",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectSalesMan },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "自动生成",
                                  },
                                  model: {
                                    value: _vm.form.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "status", $$v)
                                    },
                                    expression: "form.status",
                                  },
                                },
                                _vm._l(_vm.statusOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建人" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.createUser,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createUser", $$v)
                                  },
                                  expression: "form.createUser",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.createTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createTime", $$v)
                                  },
                                  expression: "form.createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否终端客户",
                                prop: "customerCategory",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.customerCategory,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "customerCategory",
                                        $$v
                                      )
                                    },
                                    expression: "form.customerCategory",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否集团内客户",
                                prop: "groupCustomerOrNot",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.groupCustomerOrNot,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "groupCustomerOrNot",
                                        $$v
                                      )
                                    },
                                    expression: "form.groupCustomerOrNot",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "是否黑名单", prop: "blacklist" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.blacklist,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "blacklist", $$v)
                                    },
                                    expression: "form.blacklist",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "资质", prop: "competency" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.form.competency,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "competency", $$v)
                                    },
                                    expression: "form.competency",
                                  },
                                },
                                _vm._l(_vm.competencyCode, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      value: item.code,
                                      label: item.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 18 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "变更原因", prop: "changeNote" },
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.changeNote,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "changeNote", $$v)
                                  },
                                  expression: "form.changeNote",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "销售组织" } },
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "10px 0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: {
                            click: function ($event) {
                              return _vm.onAdd("销售")
                            },
                          },
                        },
                        [_vm._v("选择销售组织")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-table",
                        {
                          ref: "elTable",
                          attrs: {
                            data: _vm.form.customerApplyLineChangeList,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "销售组织代码",
                              align: "left",
                              "show-overflow-tooltip": "",
                              width: "400",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "salesOrganizationNumber",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.salesOrganizationNumber
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "销售组织名称",
                              align: "left",
                              "show-overflow-tooltip": "",
                              width: "auto",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "salesOrganizationName",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.salesOrganizationName
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              fixed: "right",
                              width: "200",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeletes(
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除 ")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "公司代码" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-table",
                        {
                          ref: "elTable",
                          attrs: {
                            data: _vm.form.customerFinanceLineChangeList,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "公司代码",
                              align: "left",
                              "show-overflow-tooltip": "",
                              width: "400",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "companyCode" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.companyCode) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "公司名称",
                              align: "left",
                              "show-overflow-tooltip": "",
                              width: "auto",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "companyName" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.companyName) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "客户开票信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发票抬头" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.invoiceTitle,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "invoiceTitle", $$v)
                                  },
                                  expression: "form.invoiceTitle",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "纳税人识别号" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.taxpayerIdentifyNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "taxpayerIdentifyNo",
                                      $$v
                                    )
                                  },
                                  expression: "form.taxpayerIdentifyNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "电话" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "phone", $$v)
                                  },
                                  expression: "form.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开户银行" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.bankOfDeposit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "bankOfDeposit", $$v)
                                  },
                                  expression: "form.bankOfDeposit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "账号名称" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.accountName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "accountName", $$v)
                                  },
                                  expression: "form.accountName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "银行账号" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.bankAccount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "bankAccount", $$v)
                                  },
                                  expression: "form.bankAccount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "附件信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("FileUpload", {
                        attrs: {
                          value: _vm.form.customerAccessoryChangeList,
                          "show-delect":
                            _vm.form.status <= 1 || !_vm.form.status,
                          "is-show-tip": false,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "customerAccessoryChangeList",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "流程审批" } },
                [
                  _vm.form.status <= 1 || _vm.form.status == null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "选择流程模板",
                                        prop: "flowPathTemplateId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "选择模板" },
                                          on: {
                                            change: _vm.getFlowTempInfoList,
                                          },
                                          model: {
                                            value: _vm.form.flowPathTemplateId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "flowPathTemplateId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.flowPathTemplateId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.flowPathOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.templateName,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.flowPathNodePersonModels &&
                          _vm.form.flowPathNodePersonModels.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "elTable",
                                  staticStyle: { width: "50%" },
                                  attrs: {
                                    data: _vm.form.flowPathNodePersonModels,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "节点名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "nodePersonName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.nodePersonName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3691834225
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "审批人",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "auto",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flowPathNodePersonModels." +
                                                      scope.$index +
                                                      ".nodePerson",
                                                    rules:
                                                      _vm
                                                        .flowPathNodePersonModels
                                                        .nodePerson,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.nodePerson,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nodePerson",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nodePerson",
                                                      },
                                                    },
                                                    [
                                                      scope.row.variable
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              slot: "append",
                                                              icon: "el-icon-search",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectNodePerson(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            slot: "append",
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4032877737
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("Flow", {
                    ref: "flow",
                    attrs: {
                      disabled: _vm.type == "查看" || _vm.form.status > 2,
                      "custom-event": true,
                      "flow-id": _vm.form.flowId,
                    },
                    on: {
                      flowLoad: _vm.flowLoad,
                      complete: _vm.onComplete,
                      refresh: _vm.flowRefresh,
                      rejectTo: _vm.flowRejectTo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading, type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存 ")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndSubmit()
                            },
                          },
                        },
                        [_vm._v(" 提交审核 ")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择业务员",
            visible: _vm.visible,
            width: "50%",
            "before-close": _vm.close,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.salesManData, border: "", height: "300" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "业务员",
                  align: "left",
                  prop: "name",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "更新人",
                  align: "left",
                  prop: "updateUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "更新时间",
                  align: "left",
                  prop: "updateTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("el-col", { attrs: { span: 12 } }),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("pagination", {
                    attrs: {
                      total: _vm.pagination.total,
                      page: _vm.pagination.current,
                      limit: _vm.pagination.size,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.pagination, "size", $event)
                      },
                      pagination: _vm.getSalesman,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择客户",
            visible: _vm.open,
            width: "50%",
            "before-close": _vm.beforeClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.conditions.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.conditions, "customerApplyName", $$v)
                      },
                      expression: "conditions.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getCustomer("refresh")
                        },
                      },
                    },
                    [_vm._v("查询 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              staticClass: "selectNone",
              attrs: { data: _vm.customerData, border: "", height: "300" },
              on: { "selection-change": _vm.handleCustomerSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.paginations.total,
                  page: _vm.paginations.current,
                  limit: _vm.paginations.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.paginations, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.paginations, "size", $event)
                  },
                  pagination: _vm.getCustomer,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.beforeClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择审批人",
            visible: _vm.showObj.nodePerson,
            width: "30%",
            "before-close": _vm.nodePersonClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "nodePerson", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入审批人名称" },
                    model: {
                      value: _vm.condition.nodePerson.nodePerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.nodePerson, "nodePerson", $$v)
                      },
                      expression: "condition.nodePerson.nodePerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNodePersonDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.nodePerson, border: "", height: "300" },
              on: { "selection-change": _vm.handleNodePersonSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审批人",
                  align: "left",
                  prop: "nodePerson",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.nodePerson.total,
                  page: _vm.pagination.nodePerson.current,
                  limit: _vm.pagination.nodePerson.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.nodePerson,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.nodePerson, "size", $event)
                  },
                  pagination: _vm.getNodePersonDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.nodePersonClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nodePersonConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择销售组织",
            visible: _vm.salesDialog,
            width: "50%",
            "before-close": _vm.salesDialogClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.salesDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.salesOrganizationOptions,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSalesSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织代码",
                  align: "left",
                  prop: "salesOrganizationNumber",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织描述",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.salesDialogClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.salesConfirm } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择公司",
            visible: _vm.companyDialog,
            width: "50%",
            "before-close": _vm.companyDialogClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.companyDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.companyOptions, border: "", height: "300" },
              on: { "selection-change": _vm.handleCompanySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "40" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "公司代码",
                  align: "left",
                  prop: "companyCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "公司描述",
                  align: "left",
                  prop: "companyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.companyDialogClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.companyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }